module.exports = __webpack_public_path__ + "assets/img/scan-report-1.491b547b.svg";